<template>
  <div>
    <main-header />
    <tabs
      ref="tabs"
      :options="{ useUrlFragment: false, defaultTabHash: 'general' }"
      class="spl-edit-tabs-flight">
      <tab id="defaultFilter" name="Edit/Create Flight">
        <div class="daily-cargo-edit-flight-administration">
          <div class="row">
            <div class="col12">
              <div class="spl-h3 spl-h3--first">
                General Info
              </div>
              <div class="col3">
                <form-label>Tour</form-label>
                <form-filtered-select
                  v-model="dailyCargoFlight.Daily_Cargo_Flight_Routing"
                  :options="routeOptions"
                  :selected-key="dailyCargoFlight.Daily_Cargo_Flight_Routing"
                  placeholder="Tour" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col12">
              <div class="spl-h3">
                Flight Info
              </div>
              <div class="col3">
                <form-label>Flight Operator</form-label>
                <form-input
                  v-model="dailyCargoFlight.Daily_Cargo_Flight_Operator"
                  placeholder="Flight Operator"
                  data-cy="edit-daily-cargo-flight-operator" />
              </div>
              <div class="col3">
                <form-label>Flight Aircraft</form-label>
                <form-input
                  v-model="dailyCargoFlight.Daily_Cargo_Flight_Aircraft"
                  placeholder="Flight Aircraft"
                  data-cy="edit-daily-cargo-flight-aircraft" />
              </div>
              <div class="col3">
                <form-label>Flight Registration</form-label>
                <form-input
                  v-model="dailyCargoFlight.Daily_Cargo_Flight_Registration"
                  placeholder="Flight Registration"
                  data-cy="edit-daily-cargo-flight-registration" />
              </div>
              <div class="col3">
                <form-label>Flight Number</form-label>
                <form-input
                  v-model="dailyCargoFlight.Daily_Cargo_Flight_Number"
                  placeholder="Flight Number"
                  data-cy="edit-daily-cargo-flight-number" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col12">
              <div class="spl-h3 spl-h3--first">
                Estimated Time
              </div>
              <div class="col3" style="padding-bottom: 100px;">
                <form-label>Est. Time of Departure</form-label>
                <form-input
                  v-model="dailyCargoFlight.Estimated_Time_Of_Departure"
                  v-mask="['##:##']"
                  placeholder="Est. Time of Departure"
                  data-cy="edit-daily-cargo-estimated-departure" />
              </div>
              <div class="col3">
                <form-label>Est. Time of Arrival</form-label>
                <form-input
                  v-model="dailyCargoFlight.Estimated_Time_Of_Arrival"
                  v-mask="['##:##']"
                  placeholder="Est. Time of Arrival"
                  data-cy="edit-daily-cargo-estimated-arrival" />
              </div>
            </div>
          </div>
        </div>
      </tab>
    </tabs>
    <div>
      <daily-cargo-edit-action-bar
        @onSave="handleSave"
        @onCancel="handleCancel" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import MessageDialog from '@/components/shared/message-dialog'
import { create } from 'vue-modal-dialogs'
import Helpers from '@/helpers.vue'
import constants from '@/constants'
const messageDialog = create(MessageDialog, 'content')

export default {
  mixins: [Helpers],
  data () {
    return {
      routeLabel: '',
      dailyCargoFlight: {},
      constants
    }
  },
  created () {
    this.dailyCargoFlight = this.$route.params
    this.dailyCargoFlight.Daily_Cargo_Flight_Routing = parseInt(this.dailyCargoFlight.Daily_Cargo_Flight_Routing)
  },
  computed: {
    ...mapGetters('dailyCargo', ['routeOptions'])
  },
  methods: {
    ...mapActions('dailyCargo', ['saveDailyCargoFlight']),
    validateAndSend () {
      this.isLoading = true
      var flightList = []
      flightList.push(this.dailyCargoFlight)
      this.saveDailyCargoFlight(flightList).then((response) => {
        this.isLoading = false
        this.$router.push('/daily-cargo-general/3')
        this.$forceUpdate()
      }).catch((error) => {
        this.isLoading = false
        messageDialog('Something went wrong: ' + error.ExceptionMessage)
      })
    },
    // *********************** Handle Actionbar *************************
    handleSave () {
      this.validateAndSend()
    },
    handleCancel () {
      this.$router.push('/daily-cargo-general/3')
    }
  }
}
</script>
<style lang="scss">
  @import '../../../variables.scss';

  .spl-edit-tabs-flight {
    background-color: #fff7e7;
    .tabs-component-panels {
      padding: 0 $mainPadding;
    }
    .tabs-component-tabs {
      background-color: $yellowButtonLabelHover;
      padding: 3px $mainPadding 13px $mainPadding;
      margin: 0;
      display: flex;
      .tabs-component-tab {
        color: white;
        padding-bottom: 5px;
        margin: 12px 10px 0 10px;
        list-style: none;
        font-size: 14px;
        &.is-active {
          color: #ebaa28;
          border-bottom: 2px solid #ebaa28;
        }
      }
    }
  }
  .daily-cargo-edit-flight-administration {
    background-color: #fff7e7;
    & .spl-h3 {
      margin-top: 30px;
      margin-bottom: 40px;
      position: relative;

      &::before {
        content: "";
        border-bottom: 3px solid black;
        opacity: 0.3;
        width: 30px;
        position: absolute;
        bottom: -13px;
      }
    }
    & .spl-h3--first {
      padding-top: 30px;
      margin-top: 0px !important;
    }
    & .spl-h3--last {
      padding-bottom: 100px;
    }
    &__date {
      display: grid;
      grid-template-columns: 24% 24% 24% 24%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 1%;
      position: relative;

      div {
        background-color: $grey_95;
        border-radius: 5px;
        padding: 3px;
      }

      .spl-checkbox-group__item__label {
        margin-bottom: 10px;
      }
    }

    &__fields, &__postal, &__references, &__weekend-delivery {
      display: grid;
      grid-template-columns: 24% 24% 24% 24%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 1%;
      div {
        margin-bottom: 10px;
      }
    }
  }
</style>
